import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { fetchProfile } from '../api/profile';
import { getProfileFallback } from './profileFallback';

const SiteProfileContext = createContext(getProfileFallback('en'));

export const SiteProfileProvider = ({ children }) => {
  const { i18n } = useTranslation();
  const language = i18n.resolvedLanguage?.startsWith('zh') ? 'zh' : 'en';
  const fallback = useMemo(() => getProfileFallback(language), [language]);
  const [profile, setProfile] = useState(fallback);

  useEffect(() => {
    let active = true;
    setProfile(fallback);
    fetchProfile(language)
      .then((data) => { if (active && data) setProfile({ ...fallback, ...data }); })
      .catch(() => {
        // The public site remains usable while the backend is unavailable.
      });
    return () => { active = false; };
  }, [fallback, language]);

  return <SiteProfileContext.Provider value={profile}>{children}</SiteProfileContext.Provider>;
};

export const useSiteProfile = () => useContext(SiteProfileContext);
